import { writable } from "svelte/store";

function createChatSessionStore() {
  const { subscribe, set, update } = writable(null);

  return {
    subscribe,
    notifyNameChanged: (sessionId, newName) => {
      set({ sessionId, type: "nameChanged", newName });
      // Reset after subscribers have had a chance to react
      setTimeout(() => set(null), 100);
    },
    notifyQuestionAdded: (sessionId, timestamp) => {
      set({ sessionId, type: "questionAdded", timestamp });
      // Reset after subscribers have had a chance to react
      setTimeout(() => {
        set(null);
      }, 200);
    },
    notifyRefresh: (sessionId) => {
      set({ sessionId, type: "refresh" });
      // Reset after subscribers have had a chance to react
      setTimeout(() => set(null), 100);
    },
    clear: () => set(null),
  };
}

export const chatSessionStore = createChatSessionStore();
